import { GEnum } from '@/constants/enum.defination';
import { Serializable } from '@/models/core/serializable';
import { NumberUtils } from '@/utils/number.utils';
import i18n from '@/i18n';

export class StudentTrends implements Serializable<StudentTrends> {
  latestResults: TrendResult[] = []; // 直近の受検結果
  comparisonResults: TrendComparison[] = []; // 前回受検結果との比較

  deserialize(input: any): StudentTrends {
    if (input.latestResults) {
      this.latestResults = input.latestResults.map((latestResult: TrendResult) => new TrendResult().deserialize(latestResult));
    }
    if (input.comparisonResults) {
      this.comparisonResults = input.comparisonResults.map((comparisonResult: TrendComparison) => new TrendComparison().deserialize(comparisonResult));
    }
    return this;
  }
}

export class TrendResult implements Serializable<TrendResult> {
  trendID: number;
  masterID: number;
  trendName: string;
  trendScore: number;
  examDate: string;

  deserialize(input: any): TrendResult {
    this.trendID = input.trendID;
    this.masterID = input.masterID;
    this.trendName = input.trendName;
    this.trendScore = input.trendScore;
    this.examDate = input.examDate;
    return this;
  }

  get color(): string {
    switch (this.masterID) {
      case GEnum.Trend.MasterID18:
      case GEnum.Trend.MasterID23:
        return '#0050b3';
      case GEnum.Trend.MasterID19:
      case GEnum.Trend.MasterID24:
        return '#237804';
      case GEnum.Trend.MasterID20:
      case GEnum.Trend.MasterID25:
        return '#ad8b00';
      case GEnum.Trend.MasterID21:
        return '#391085';
    }
  }

  get displayTrendName(): string {
    switch (this.masterID) {
      case GEnum.Trend.MasterID18:
      case GEnum.Trend.MasterID23:
        return i18n.t('SELF_ESTEEM').toString();
      case GEnum.Trend.MasterID19:
      case GEnum.Trend.MasterID24:
        return i18n.t('PSYCHOLOGICAL_SAFETY').toString();
      case GEnum.Trend.MasterID20:
      case GEnum.Trend.MasterID25:
        return i18n.t('SELF_EFFICACY').toString();
      case GEnum.Trend.MasterID21:
        return i18n.t('NUMANITIES_OR_SCIENCES').toString();
      default:
        return this.trendName;
    }
  }

  get isHumanitiesOrSciences(): boolean {
    return this.masterID === GEnum.Trend.MasterID21;
  }
}

export class TrendComparison implements Serializable<TrendComparison> {
  trendID: number;
  masterID: number;
  trendName: string;
  latestTrendScore: number;
  latestExamDate: string;
  lastTrendScore: number;
  lastExamDate: string;

  deserialize(input: any): TrendComparison {
    this.trendID = input.trendID;
    this.masterID = input.masterID;
    this.trendName = input.trendName;
    this.latestTrendScore = input.latestTrendScore;
    this.latestExamDate = input.latestExamDate;
    this.lastTrendScore = input.lastTrendScore;
    this.lastExamDate = input.lastExamDate;
    return this;
  }

  get latestTrendScoreForDisplay(): number | null {
    // 画面上、-100から100のレンジに収まるように50倍
    if (this.latestTrendScore) return NumberUtils.plusFloorAndMinusCeil(this.latestTrendScore * 50);
    return null;
  }

  get lastTrendScoreForDisplay(): number | null {
    // 画面上、-100から100のレンジに収まるように50倍
    if (this.lastTrendScore) return NumberUtils.plusFloorAndMinusCeil(this.lastTrendScore * 50);
    return null;
  }

  get isTrendScoreLess(): boolean {
    return this.latestTrendScore < this.lastTrendScore;
  }

  get isHumanitiesOrSciences(): boolean {
    return this.masterID === GEnum.Trend.MasterID21;
  }

  get displayTrendName(): string {
    switch (this.masterID) {
      case GEnum.Trend.MasterID18:
      case GEnum.Trend.MasterID23:
        return i18n.t('SELF_ESTEEM').toString();
      case GEnum.Trend.MasterID19:
      case GEnum.Trend.MasterID24:
        return i18n.t('PSYCHOLOGICAL_SAFETY').toString();
      case GEnum.Trend.MasterID20:
      case GEnum.Trend.MasterID25:
        return i18n.t('SELF_EFFICACY').toString();
      case GEnum.Trend.MasterID21:
        return i18n.t('NUMANITIES_OR_SCIENCES').toString();
      default:
        return this.trendName;
    }
  }
}
